import { useMapEvents } from "react-leaflet";

export default function MapClickHandler({ onLocationSelect }) {
	useMapEvents({ click(e) { onLocationSelect(e.latlng.lat, e.latlng.lng); } });
	return null;
}